import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';

export const EditorContainer: React.FC<{
  children: React.ReactNode;
  editorRef: React.RefObject<HTMLDivElement | null>;
  handleClear: (e: React.MouseEvent) => void;
  isError?: boolean;
}> = ({ children, editorRef, handleClear, isError }) => {
  const { palette } = useTheme();

  return (
    <Box
      ref={editorRef}
      data-testid="query-builder-input"
      sx={{
        alignItems: 'start',
        border: `1px solid ${isError ? palette.error.main : palette.primary.main}`,
        borderRadius: 1,
        color: palette.text.secondary,
        display: 'grid',
        gap: 1,
        gridTemplateColumns: 'auto 1fr auto',
        minHeight: '39px',
        position: 'relative',
        px: 1,
        py: 0.25,
      }}
    >
      <Box
        sx={{
          alignItems: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          pt: 0.75,
        }}
      >
        <SearchIcon
          sx={{
            color: palette.neutral[400],
            fontSize: 20,
          }}
        />
      </Box>

      <Box
        sx={{
          '& [data-slate-placeholder]': {
            pt: 0.15,
          },
          alignItems: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 0.75,
          height: '100%',
          minWidth: 0,
        }}
      >
        {children}
      </Box>

      <Box
        sx={{
          alignItems: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          pt: 0.3,
        }}
      >
        <IconButton
          aria-label="Clear filter"
          onMouseDown={handleClear}
          size="small"
          sx={{
            color: palette.neutral[500],
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};
